export const SATELLITE_REDIRECT_KEY = "clerk_satellite_redirect";
export const SATELLITE_REDIRECT_TTL_MS = 5 * 60 * 1000; // 5 min

/** Satellite domains allowed to receive post-auth redirects (must match ClerkProvider allowedRedirectOrigins) */
export const ALLOWED_REDIRECT_ORIGINS = [
  "https://app.startupfuel.com",
  "https://staging.startupfuel.com",
  "https://dev.startupfuel.com",
] as const;

export function getValidRedirectUrl(redirectUrl: string | null): string | null {
  if (!redirectUrl) return null;

  // Same-origin relative path. Resolve it against the current origin rather
  // than pattern-matching the prefix: the URL parser strips tab/LF/CR before
  // parsing, so "/\t/evil.com" would slip past a literal "//" check and then
  // resolve to an off-origin URL at the navigation sink.
  if (redirectUrl.startsWith("/")) {
    try {
      const url = new URL(redirectUrl, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      // Dot-segment collapsing can leave a pathname beginning with "//", which
      // the navigation sink would re-parse as an authority and follow
      // off-origin. No legitimate path normalises to that, so reject it.
      if (url.pathname.startsWith("//")) return null;
      return url.pathname + url.search + url.hash;
    } catch {
      return null;
    }
  }

  try {
    const url = new URL(redirectUrl);
    if (ALLOWED_REDIRECT_ORIGINS.includes(url.origin as (typeof ALLOWED_REDIRECT_ORIGINS)[number])) {
      return redirectUrl;
    }
  } catch {
    // Invalid URL
  }
  return null;
}
